import { createSelector } from "@reduxjs/toolkit";
export const getSearch = (state) => state.search;
export const getSearchSegments = (state) => state.search.searchSegments;
export const getSearchType = (state) => state.search.type;
export const getNoOfAdults = (state) => state.search.adults;
export const getNoOfChildren = (state) => state.search.children.length;
export const getChildrensAges = (state) => state.search.children;
export const getFilters = (state) => state.search.filters;
export const getPage = (state) => state.search.page;
export const getCabinClass = (state) => state.search.cabinClass;
export const getSort = (state) => state.search.sort;
export const getArrivalPlace = createSelector((state) => state.search.searchSegments[0]?.to, (arrivalSegments) => {
    const arrivalPlace = arrivalSegments?.[arrivalSegments?.length - 1];
    return { code: arrivalPlace?.code, type: arrivalPlace?.type };
});
export const getLastDepartureDate = (state) => state.search.type === "ROUNDTRIP"
    ? state.search.searchSegments?.[state.search.searchSegments.length - 1]?.returnDate
    : state.search.searchSegments[0]?.departureDate;
export const getArrivalCountryCode = (state) => state.search.searchSegments[0]?.to?.[state.search.searchSegments[0]?.to?.length - 1]?.country;
export const getFiltersDraft = (state) => state.search.filtersDraft;
export const getFiltersDraftOutbound = (state) => state.search.filtersDraftOutbound;
export const getFiltersDraftInbound = (state) => state.search.filtersDraftInbound;
export const getIsFiltersApplied = (state) => {
    const filters = state.search?.filters;
    const isSomethingApplied = [
        filters?.stops !== undefined,
        filters?.airlines?.length,
        filters?.allDeals,
        filters?.airports?.length,
        filters?.arrivalIntervals?.length,
        filters?.departureIntervals?.length,
        filters?.duration,
        filters?.flightTimes?.length,
        filters?.includedBaggage?.length,
        filters?.maxBudget,
        filters?.maxBudgetPerAdult,
        filters?.maxLayoverDuration,
        filters?.shortLayoverConnection !== false && filters?.shortLayoverConnection !== undefined
    ].some(Boolean);
    return isSomethingApplied;
};
